import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';

const FlyoutTrigger = (_param)=>{
    var { children , className , isMenuOpen , title  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "className",
        "isMenuOpen",
        "title"
    ]);
    const classNames = classnames('flyout-trigger', className, {
        'flyout-trigger--menu-open': isMenuOpen
    });
    return /*#__PURE__*/ React__default.createElement("button", swcHelpers.extends({}, rest, {
        "aria-label": title,
        "aria-expanded": isMenuOpen,
        "aria-haspopup": true,
        className: classNames
    }), children, /*#__PURE__*/ React__default.createElement(Icon, {
        name: "chevron-down",
        className: "flyout-trigger__icon"
    }));
};
var FlyoutTrigger$1 = FlyoutTrigger;

export { FlyoutTrigger$1 as default };
//# sourceMappingURL=FlyoutTrigger.js.map
